module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "margin-top": "3px"
    }
  }, [_c('el-carousel', {
    attrs: {
      "interval": 5000,
      "arrow": "always"
    }
  }, _vm._l((_vm.indexData.logoImageList), function(item) {
    return _c('el-carousel-item', [_c('img', {
      staticStyle: {
        "width": "100%",
        "height": "100%",
        "border-radius": "4px"
      },
      attrs: {
        "src": _vm.globalUrl.resourceUrl + item.imageUrl,
        "alt": ""
      }
    })])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "cpy_info"
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("公司简介")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "padding": "3px 0"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.clickToRouter('/cpyIntroduction')
      }
    }
  }, [_vm._v("更多")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text2 item",
    domProps: {
      "innerHTML": _vm._s(_vm.indexData.cpyInfo)
    }
  })])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "article"
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("政策法规")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "padding": "3px 0"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.clickToRouter('/policyList')
      }
    }
  }, [_vm._v("更多")])], 1), _vm._v(" "), _c('ul', {
    staticClass: "article-list"
  }, _vm._l((_vm.indexData.policyRegulationList), function(item) {
    return _c('li', [_c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "content": item.title,
        "placement": "top-start"
      }
    }, [_c('router-link', {
      staticClass: "show-ellipsis",
      attrs: {
        "to": {
          path: '/policyContent?contentId=' + item.id
        }
      }
    }, [_vm._v(_vm._s(item.title))])], 1), _vm._v(" "), _c('span', {
      staticClass: "fr"
    }, [_vm._v(_vm._s(item.publishTime))]), _vm._v(" "), _c('span', {
      staticClass: "clearfix"
    })], 1)
  }))])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "article"
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("政府采购")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "padding": "3px 0"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.clickToRouter('/purchaseList')
      }
    }
  }, [_vm._v("更多")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, _vm._l((_vm.indexData.govPurchaseList), function(item) {
    return _c('li', [_c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "content": item.title,
        "placement": "top-start"
      }
    }, [_c('router-link', {
      staticClass: "show-ellipsis",
      attrs: {
        "to": {
          path: '/purchaseContent?contentId=' + item.id
        }
      }
    }, [_vm._v(_vm._s(item.title))])], 1), _vm._v(" "), _c('span', {
      staticClass: "fr"
    }, [_vm._v(_vm._s(item.publishTime))]), _vm._v(" "), _c('span', {
      staticClass: "clearfix"
    })], 1)
  }))])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "article"
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("工程招标信息")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "padding": "3px 0"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.clickToRouter('/tenderingList')
      }
    }
  }, [_vm._v("更多")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, _vm._l((_vm.indexData.projectTenderingList), function(item) {
    return _c('li', [_c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "content": item.title,
        "placement": "top-start"
      }
    }, [_c('router-link', {
      staticClass: "show-ellipsis",
      attrs: {
        "to": {
          path: '/tenderingContent?contentId=' + item.id
        }
      }
    }, [_vm._v(_vm._s(item.title))])], 1), _vm._v(" "), _c('span', {
      staticClass: "fr"
    }, [_vm._v(_vm._s(item.publishTime))]), _vm._v(" "), _c('span', {
      staticClass: "clearfix"
    })], 1)
  }))])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "article"
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("收费标准")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "padding": "3px 0"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.clickToRouter('/feeList')
      }
    }
  }, [_vm._v("更多")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, _vm._l((_vm.indexData.feeStandardList), function(item) {
    return _c('li', [_c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "content": item.title,
        "placement": "top-start"
      }
    }, [_c('router-link', {
      staticClass: "show-ellipsis",
      attrs: {
        "to": {
          path: '/feeContent?contentId=' + item.id
        }
      }
    }, [_vm._v(_vm._s(item.title))])], 1), _vm._v(" "), _c('span', {
      staticClass: "fr"
    }, [_vm._v(_vm._s(item.publishTime))]), _vm._v(" "), _c('span', {
      staticClass: "clearfix"
    })], 1)
  }))])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer_content"
  }, [_c('h3', {
    staticStyle: {
      "color": "#ff8a23"
    }
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('p', [_vm._v(" 电话：" + _vm._s(_vm.indexData.telephone))]), _vm._v(" "), _c('p', [_vm._v(" 邮箱：" + _vm._s(_vm.indexData.email))]), _vm._v(" "), _c('p', [_vm._v(" 地址：" + _vm._s(_vm.indexData.address))]), _vm._v(" "), _vm._m(0)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("备案号："), _c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn/",
      "target": "_blank"
    }
  }, [_vm._v("粤ICP备19061618号")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-290c2e3e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index.vue
// module id = 233
// module chunks = 2